import React from 'react';
import {FormModal} from './index';

interface GenericSettingsModalProps<T = number> {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  entityId: T;
  FormComponent: React.ComponentType<any>;
  entityIdPropName?: string;
  formProps?: Record<string, any>;
  size?: 'sm' | 'lg' | 'xl';
  maxWidth?: string;
  includeOnSave?: boolean;
}

const GenericSettingsModal = <T = number,>({
    isOpen,
    onClose,
    title,
    entityId,
    FormComponent,
    entityIdPropName,
    formProps = {},
    size = 'lg',
    maxWidth = '12',
    includeOnSave = true,
}: GenericSettingsModalProps<T>) => {
    const entityProps = entityIdPropName 
        ? {[entityIdPropName]: entityId}
        : getDefaultEntityIdProp(entityId);

    const saveProps = includeOnSave ? {onSave: onClose} : {};

    const allProps = {
        ...formProps,
        ...entityProps,
        ...saveProps,
    };

    return (
        <FormModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            maxWidth={maxWidth}
        >
            <FormComponent {...allProps} />
        </FormModal>
    );
};

function getDefaultEntityIdProp<T>(entityId: T): Record<string, T> {
    return {objId: entityId} as Record<string, T>;
}

export default React.memo(GenericSettingsModal) as <T = number>(
  props: GenericSettingsModalProps<T>
) => JSX.Element;
